import { render, staticRenderFns } from "./UpdateStudentGroup.vue?vue&type=template&id=05d54172&scoped=true"
import script from "./UpdateStudentGroup.vue?vue&type=script&lang=js"
export * from "./UpdateStudentGroup.vue?vue&type=script&lang=js"
import style0 from "./UpdateStudentGroup.vue?vue&type=style&index=0&id=05d54172&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d54172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d54172')) {
      api.createRecord('05d54172', component.options)
    } else {
      api.reload('05d54172', component.options)
    }
    module.hot.accept("./UpdateStudentGroup.vue?vue&type=template&id=05d54172&scoped=true", function () {
      api.rerender('05d54172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/UpdateStudentGroup.vue"
export default component.exports